interface WheelHandlerConfig {
  field: keyof Record<string, unknown>;
  step?: number;
  shiftStep?: number;
  ctrlStep?: number;
  maxValue?: number;
  minValue?: number;
  formatToFixed?: number;
}

export const createWheelHandler = <T extends Record<string, unknown>>(
  data: T,
  setValue: React.Dispatch<React.SetStateAction<T>>,
  config: WheelHandlerConfig,
  renewTotalData?: () => void,
): ((e: React.WheelEvent) => void) => {
  const {
    field,
    step = 1,
    shiftStep = 10,
    ctrlStep = 0.1,
    maxValue,
    minValue = 0,
    formatToFixed,
  } = config;

  return (e: React.WheelEvent) => {
    // e.preventDefault();

    const currentValue = data[field];
    const numValue = isNaN(parseFloat(currentValue.toString()))
      ? 0
      : parseFloat(currentValue.toString());

    let newValue: number;
    if (e.ctrlKey) {
      newValue = e.deltaY < 0 ? numValue + ctrlStep : numValue - ctrlStep;
    } else if (e.shiftKey) {
      newValue = e.deltaY < 0 ? numValue + shiftStep : numValue - shiftStep;
    } else {
      newValue = e.deltaY < 0 ? numValue + step : numValue - step;
    }

    newValue = Math.max(minValue, Math.min(newValue, maxValue ?? Infinity));

    const newData = { ...data };
    newData[field] = Number(newValue.toFixed(1));

    setValue(newData);
    renewTotalData?.();
  };
};
